import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { euro } from './Variables';
import '../components/agreement.css';
import { dateSuffix, shortDateString } from '../Functions/Generic';

export class Agreement extends Component {
    displayName = Agreement.name

    constructor(props) {
        super(props);
        this.props.changeLogo("user");

    }

    render() {        
        return (
            <div className="agreement-page" style={{ width: "100%" }}> 
                <div className="desktop-only">
                    <div className="large-title">
                        <h2 className="text-center"> Your Agreement(s) </h2>
                    </div>
                </div>
                <div className="container">
                    <h1 className="mobile-only">Your Agreement(s)</h1>
                    <div className="outer">
                        <AgreementDetail {...this.props.summary}/>
                    </div>
                    <div className="form-group text-center">
                        <Link to={"/"} className="btn btn-lg btn-primary">Home</Link>
                    </div>
                </div>
            </div>
        );
    }
}

class AgreementDetail extends Component {
    render() {
        const {
            loanReferenceNumber,
            payoutAmount,
            currentBalance,
            rmiAmount,
            rmiRegularPaymentDay,
            startDate,
            endDate,
            totalRepayment,
            term,
            costPer100Euros
        } = this.props;
        return (
            <div className="agreement-detail-large">
                <div className="agreement-row">
                    <div className="agreement-col">
                        <h4>Agreement Number</h4>
                        <p>{loanReferenceNumber}</p>
                    </div>
                    <div className="agreement-col">
                        <h4>Loan Amount</h4>
                        <p>{euro}{payoutAmount.toFixed(2)}</p>
                    </div>
                    <div className="agreement-col">
                        <h4>Loan Term</h4>
                        <p>{term}</p>
                    </div>
                    <div className="agreement-col">
                        <h4>Current Balance</h4>
                        <p>{euro}{currentBalance.toFixed(2)}</p>
                    </div>
                    <div className="agreement-col">
                        <h4>Repayment Amount</h4>
                        <p>{euro}{rmiAmount.toFixed(2)}</p>
                    </div>
                </div>
                <div className="agreement-row">
                    <div className="agreement-col">
                        <h4>Payment Date</h4>
                        <p>{dateSuffix(rmiRegularPaymentDay)}</p>
                    </div>
                    <div className="agreement-col">
                        <h4>Start Date</h4>
                        <p>{shortDateString(startDate, "-")}</p>
                    </div>
                    <div className="agreement-col">
                        <h4>End Date</h4>
                        <p>{shortDateString(endDate, "-")}</p>
                    </div>
                    <div className="agreement-col">
                        <h4>Total Repayable</h4>
                        <p>€{totalRepayment.toFixed(2)}</p>
                    </div>
                    <div className="agreement-col">
                        <h4>APR</h4>
                        <p>49.9%</p>
                    </div>
                </div>
                <div className="agreement-row">
                    <div className="agreement-col">
                        <h4>Cost per €100</h4>
                        <p>€{costPer100Euros.toFixed(2)}</p>
                    </div>
                </div>
            </div>
        );
    }
}

AgreementDetail.defaultProps = {
    loanReferenceNumber: 0,
    payoutAmount: 0,
    currentBalance: 0,
    rmiAmount: 0,
    rmiRegularPaymentDay: 0,
    startDate: 0,
    endDate: 0,
    totalRepayment: 0,
    term: 0,
    costPer100Euros: 0
};


// WEBPACK FOOTER //
// ./src/components/Agreement.js